<template>
  <el-dialog
    width="750px"
    class="linkDialog"
    title="设置跳转逻辑"
    :close-on-click-modal="false"
    :visible.sync="dialogShow"
    @close="dialogClose"
  >
    <span class="sub-title">
      <i class="el-icon-info"></i>包含选中分值
    </span>
    <div v-for="(item, i) in starEntityList" :key="i">
      <starLogic
        :count="starEntityList.length"
        :seqNum="i"
        :logic="item"
        :starEntityList="starEntityList"
        :linkQues="linkQues"
        :survey="survey"
        :allQues="allQues"
        :index="index"
        @changeLogic="handleChangeLogic"
        @addOrDel="handleAddOrDel"
      ></starLogic>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import starLogic from "./starLogic.vue";
import { MSG } from "../utils/utils";
export default {
  name: "linkDialogStar",
  data() {
    return {
      dialogShow: false,
      starEntityList: [{}],
      index: 0
    };
  },
  watch: {
    isShow: function() {
      this.dialogShow = this.isShow;
      this.starEntityList = this.linkQues.starEntityList || [{}];
      if (this.starEntityList.length == 0) {
        this.starEntityList = [{}];
      }
    }
  },
  props: ["linkQues", "survey", "isShow"],
  computed: {
    allQues() {
      let _arr = [];
      this.survey.pages.forEach(val => {
        val.questions.forEach(ques => {
          if (ques.id == this.linkQues.id) {
            this.index = _arr.length;
          }
          _arr.push(ques);
        });
      });
      return _arr;
    }
  },
  components: {
    starLogic
  },
  methods: {
    dialogClose() {
      this.$emit("close");
    },
    handleConfirm() {
      let list = this.starEntityList;
      let region = [];
      for (var i = 0; i < list.length; i++) {
        let item = list[i];
        if (
          item.start == undefined ||
          item.end == undefined ||
          !item.quetionId
        ) {
          MSG.error("配置未完成");
          return;
        }
        for (var j = item.start; j <= item.end; j++) {
          if (region.indexOf(j) > -1) {
            MSG.error("配置不合理");
            return;
          } else {
            region.push(j);
          }
        }
      }
      this.$emit("linkConfirm", list);
      this.dialogShow = false;
    },
    handleChangeLogic(seqNum, item) {
      this.starEntityList.splice(seqNum, 1, item);
    },
    handleAddOrDel(type, seqNum) {
      if (type == "add") {
        this.starEntityList.splice(seqNum + 1, 0, {});
      } else {
        this.starEntityList.splice(seqNum, 1);
      }
    }
  }
};
</script>

<style lang="scss">
.el-dialog__body {
  padding: 10px 20px;
}
.sub-title {
  position: relative;
  left: 120px;
  top: -40px;
  color: #888;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/linkDialogStar.vue